export default "__VITE_ASSET__C2gDXwg2__"